export default {"src":"/_next/static/media/img-payment-failed.71474088.svg","height":143,"width":143,"blurWidth":0,"blurHeight":0};